<section>
  @if (bookSelectionVisibleModal) {
    <div class="clear-coat" (click)="bookSelectionVisibleModal = false;"></div>
  }
  <div class="row">
    <div class="col-sm">
      <label for="">Book <span class="required">*</span></label>
      <div class="book selected-book" (click)="toggleBookSelection()">
        <div>{{promoWizardService.selectedBook ? promoWizardService.selectedBook.title : 'Select a Book'}}</div>
      </div>

      @if (bookSelectionVisibleModal) {
        <div class="book-list">
          <div class="triangle"></div>
          <div class="row">
            <div class="col-sm-9">
              <div class="search">
                <app-input-form
                  [form]="form"
                  [id]="filterComponents.book.key"
                  [type]="filterComponents.book.type"
                  [required]="filterComponents.book.required"
                  (keyup)="searchBooks()"
                ></app-input-form>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="new-book">
                <a href="javascript:void(0);" (click)="displayNewBookModal()">+ New Book</a>
              </div>
            </div>
          </div>
          @if (showBookSearch) {
            <ul>
              @for (book of filteredBooks; track book) {
                <li (click)="selectBook(book)">
                  <div class="image">
                    <img src="{{book.amazonImageUrl || defaultImageUrl}}" alt="{{book.title}}" />
                  </div>
                  <h4 class="title strong2">{{book.title}}</h4>
                  <div class="author">by {{book.author}}</div>
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
    <div class="col-sm">
      <app-input-form
        class="promo-wizard-input price"
        [form]="form"
        [id]="filterComponents.promoPrice.key"
        [label]="filterComponents.promoPrice.label"
        [type]="filterComponents.promoPrice.type"
        [required]="filterComponents.promoPrice.required"
        [tooltipLabel]="filterComponents.promoPrice.tooltip"
        [tooltipText]="filterComponents.promoPrice.tooltipText"
        [min]="0"
        (change)="queryAdverts()"
      ></app-input-form>
    </div>
    <div class="col-sm">
      <label for="">Genre <span class="required">*</span></label>
      <app-tooltip-card [label]="filterComponents.genres.tooltip"
      [text]="filterComponents.genres.tooltipText"></app-tooltip-card>
      <div
        class="genres-selection"
        (click)="toggleGenresModal()"
        >
        <div>{{ promoWizardService.genreList }}</div>
      </div>
      @if (genreSelectionVisibleModal) {
        <div class="genre-list">
          <div class="triangle"></div>
          <div class="categories-wrap">
            @for (category of categories; track category) {
              <div class="category-item">
                <h3 class="category-item-name">
                  <app-checkbox-form
                    [id]="category.name"
                    [value]="category.name"
                    [form]="genresForm"
                    style="float: left; margin-right: 5px;"
                  ></app-checkbox-form>
                  {{ category.name }}
                </h3>
                <ul class="genres-list">
                  @for (genre of category._children; track genre) {
                    <li class="genre-item">
                      <app-checkbox-form
                        [id]="genre.name"
                        [label]="genre.name"
                        [value]="genre.name"
                        [form]="genresForm"
                      ></app-checkbox-form>
                    </li>
                  }
                </ul>
              </div>
            }
            <div class="text-right d-block">
              <a href="javascript:void(0);" class="mr-2" (click)="clearGenres()">Clear All</a>
              <button class="button regular solid-green" (click)="toggleGenresModal()">Select Genres</button>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="col-sm">
      <app-datepicker
        [id]="filterComponents.promoStart.key"
        [label]="filterComponents.promoStart.label"
        [placeholder]="filterComponents.promoStart.placeholder"
        class="promo-wizard-input calendar"
        [startDate]="promoWizardService.startDate"
        [minDate]="minimumStartDate"
        [maxDate]="promoWizardService.endDate"
        [required]="filterComponents.promoStart.required"
        [tooltipLabel]="filterComponents.promoStart.tooltip"
        [tooltipText]="filterComponents.promoStart.tooltipText"
        (dateChange)="setStartDate($event)"
      ></app-datepicker>
    </div>
    <div class="col-sm">
      <app-datepicker
        [id]="filterComponents.promoEnd.key"
        [label]="filterComponents.promoEnd.label"
        [placeholder]="filterComponents.promoEnd.placeholder"
        class="promo-wizard-input calendar"
        [startDate]="promoWizardService.endDate"
        [minDate]="promoWizardService.startDate"
        [required]="filterComponents.promoEnd.required"
        (dateChange)="setEndDate($event)"
      ></app-datepicker>
    </div>
    <div class="col-sm">
      <button class="go" (click)="queryAdverts()">Go</button>
    </div>
  </div>
</section>
<app-add-book (bookAdded)="selectBook($event)"></app-add-book>
